import { colors, fontSizing, fontWeights, sizing } from '@chillibean/component-library';
import PropTypes from 'prop-types';
import styled from 'styled-components';

export function Pill(props) {
  const { text } = props;

  return (
    <StyledPill>
      <Text>{text}</Text>
    </StyledPill>
  );
}

Pill.propTypes = {
  text: PropTypes.string.isRequired,
};

const StyledPill = styled.div`
  display: flex;
  align-items: center;
`;

const Text = styled.div`
  color: ${colors.grey.medium};
  max-width: 90px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: ${fontSizing.medium};
  font-weight: ${fontWeights.bold};
  height: ${sizing.slarge};
`;

export default Pill;
